import { PrimaryButton } from "../../shared/layout/PrimaryButton";
import { PlusOutlined } from "@ant-design/icons";
import { formatTranslation } from "../../shared/utils/translationUtils";
import { useTranslation } from "react-i18next";
import { type ITrialsPageHeaderProps } from "./types";

/**
 * TrialsPageHeader component renders the header section of the trials page. It displays the title and a button to create a new trial.
 * The button is hidden when the page is in a loading state.
 * @param props - The props for the TrialsPageHeader component.
 * @returns A React element representing the header section of the trials page.
 */
const TrialsPageHeader = (props: ITrialsPageHeaderProps): JSX.Element => {
  const { t } = useTranslation();
  const { isLoading, handleNavigate } = props;
  return (
    <div className="head-sec">
      <h3>{formatTranslation(t("trials.title"))}</h3>
      {!isLoading && (
        <PrimaryButton
          onClick={handleNavigate}
          data-testid="create-trial-button"
        >
          <PlusOutlined /> {formatTranslation(t("trials.createButton"))}
        </PrimaryButton>
      )}
    </div>
  );
};

export default TrialsPageHeader;
